import React from 'react';
import { motion } from 'framer-motion';
import { T, Lang } from '../lib/i18n';
export function Services({
  lang
}: {
  lang: Lang;
}) {
  const t = T[lang].services;
  const services = [{
    title: t.s1_title,
    desc: t.s1_desc,
    icon: '🌐'
  }, {
    title: t.s2_title,
    desc: t.s2_desc,
    icon: '🔍'
  }, {
    title: t.s3_title,
    desc: t.s3_desc,
    icon: '📍'
  }, {
    title: t.s4_title,
    desc: t.s4_desc,
    icon: '🛒'
  }, {
    title: t.s5_title,
    desc: t.s5_desc,
    icon: '📱'
  }, {
    title: t.s6_title,
    desc: t.s6_desc,
    icon: '⚡'
  }];
  return <section id="servicios" className="bg-white py-24 px-4 md:px-8" data-id="element-370">
      <div className="max-w-[1100px] mx-auto" data-id="element-371">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-372">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl" data-id="element-373">
            <div className="inline-block bg-brand-blue-primary/10 text-brand-blue-primary text-sm font-bold px-3 py-1 rounded-full mb-4" data-id="element-374">
              {t.tag}
            </div>
            <h2 className="font-display font-extrabold text-3xl md:text-4xl text-brand-navy-dark" data-id="element-375">
              {t.h2_1}
              <span className="bg-gradient-brand bg-clip-text text-transparent" data-id="element-376">
                {t.h2_2}
              </span>
            </h2>
          </motion.div>
          <motion.p initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-brand-text-muted max-w-sm text-base" data-id="element-377">
            {t.subtitle}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-378">
          {services.map((srv, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-brand-blue-primary/10 rounded-[14px] p-8 hover:border-brand-blue-primary/25 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(30,95,212,0.05)] transition-all duration-300" data-id="element-379">
              <div className="w-10 h-10 rounded-[10px] bg-brand-blue-primary/10 flex items-center justify-center text-xl mb-6 relative" data-id="element-380">
                <div className="absolute inset-0 opacity-20 hex-bg rounded-[10px] overflow-hidden" data-id="element-381"></div>
                <span className="relative z-10" data-id="element-382">
                  {srv.icon.replace(/[\u{1F300}-\u{1F9FF}]/gu, '')}
                </span>
                {/* Fallback if emoji is stripped, though spec includes emojis. I will render the emoji directly. */}
                <span className="relative z-10" data-id="element-383">{srv.icon}</span>
              </div>
              <h3 className="font-display font-bold text-xl text-brand-navy-dark mb-3" data-id="element-384">
                {srv.title.replace(/[\u{1F300}-\u{1F9FF}]/gu, '').trim()}
              </h3>
              <p className="text-brand-text-secondary text-sm leading-relaxed" data-id="element-385">
                {srv.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}